(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/init.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
svs.tickets.init = () => {
  var _svs$tickets$data;
  svs.tickets.logger = new svs.core.log.Logger('module:tickets');
  const {
    matchPath,
    PlayerRouter
  } = svs.app.ReactRouter;
  const {
    useEffect,
    useState
  } = React;
  const {
    PICK_PATH,
    PLAY_PATH
  } = svs.tickets.play.utils.constants;
  const Route = svs.app.ReactRouter.Route;
  const Menu = svs.tickets.play.components.Menu;
  const ticketsConfig = svs.ticketgames.gameHandler.games;
  const baseUrl = svs.core.data.baseUrl;
  const PlayContainer = svs.tickets.play.containers.PlayContainer;
  const GameContainer = svs.tickets.play.containers.TicketsGameContainer;
  const branding = svs.tickets.data.templateConfig.branding;
  const availableTickets = svs.tickets.data.moduleConfig.availableTickets;
  const HiddenRoute = svs.tickets.play.containers.HiddenRoute;
  const {
    getTicketInfo,
    getMenuProduct,
    getSwishTicketInfo
  } = svs.tickets.play.utils.utils;
  const ticketDispatcher = new svs.ticketgames.ticketScratch.utils.TicketsRadioDispatcher();
  const appTimeline = new gsap.timeline();
  gsap.ticker.lagSmoothing(0);
  appTimeline.addLabel('showUsp', 0);
  appTimeline.addLabel('hideUsp', 2);
  appTimeline.addLabel('gameReady', 3);
  appTimeline.addLabel('introDone', 5);
  const menuProducts = availableTickets.map(product => {
    const foundGame = ticketsConfig.find(ticket => ticket.type.toLowerCase() === product.type.toLowerCase());
    if (!foundGame) {
      return null;
    }
    return _objectSpread(_objectSpread({}, product), foundGame);
  }).filter(p => (p === null || p === void 0 ? void 0 : p.active) && p.open);
  const DispatcherRoute = _ref => {
    let {
      children,
      isMatch
    } = _ref;
    const [dispatcherProps, setDispatcherProps] = useState(undefined);
    const [wasMatch, setWasMatch] = useState(false);
    useEffect(() => {
      if (isMatch === false && wasMatch === true) {
        setDispatcherProps(undefined);
      }
      setWasMatch(isMatch);
    }, [isMatch]);
    useEffect(() => {
      ticketDispatcher.addListeners([{
        eventName: 'PRELOAD',
        handler: data => {
          setDispatcherProps(data);
        }
      }], void 0);
    }, []);
    return isMatch || dispatcherProps ? React.createElement(React.Fragment, null, React.Children.map(children, child => React.cloneElement(child, dispatcherProps))) : null;
  };
  const hasUnscratchedTicket = ((_svs$tickets$data = svs.tickets.data) === null || _svs$tickets$data === void 0 ? void 0 : _svs$tickets$data.fetchedGames) && svs.tickets.data.fetchedGames.length > 1;
  const router = React.createElement(PlayerRouter, {
    basename: baseUrl,
    withRouter: true
  }, React.createElement("div", {
    className: "relative"
  }, branding === 'skrapspel' && React.createElement("div", {
    className: "animated-background-container",
    id: "animatedBackgroundContainer"
  })), React.createElement(Menu, {
    appTimeline: appTimeline,
    products: menuProducts,
    ticketDispatcher: ticketDispatcher
  }), React.createElement(Route, {
    component: _ref2 => {
      let {
        match,
        history
      } = _ref2;
      const routeMatch = matchPath(match.url, {
        path: PLAY_PATH,
        exact: true,
        strict: false
      });
      const ticketInfoMatch = matchPath(history.location.pathname, {
        path: [PICK_PATH, PLAY_PATH]
      });
      let wagerId;
      let skinId;
      let ticketInfo;
      let ticketNumber;
      let demo;
      let voucherCode;
      if (routeMatch) {
        var _wagerId, _ticketInfo, _availableTickets$fin;
        wagerId = routeMatch.params.wagerId.toLowerCase();

        const sameAlternativeUrlTicketTypes = availableTickets.filter(ticket => {
          var _ticket$alternativeUr;
          return ((_ticket$alternativeUr = ticket.alternativeUrl) === null || _ticket$alternativeUr === void 0 ? void 0 : _ticket$alternativeUr.toLowerCase()) === routeMatch.params.ticketType;
        }).map(ticket => ticket.type.toLowerCase());
        const ticketTypes = sameAlternativeUrlTicketTypes.length > 0 ? sameAlternativeUrlTicketTypes : [routeMatch.params.ticketType.toLowerCase()];
        ticketInfo = ticketsConfig.find(ticket => ticketTypes.includes(ticket.type.toLowerCase()) && ticket.active);
        ticketNumber = parseInt(svs.utils.paramHandler.get({
          key: 'ticketNumber'
        }).value, 10) || null;
        demo = ((_wagerId = wagerId) === null || _wagerId === void 0 ? void 0 : _wagerId.toLowerCase()) === 'demo';
        ticketDispatcher.setPaused(false);

        skinId = (_ticketInfo = ticketInfo) !== null && _ticketInfo !== void 0 && _ticketInfo.defaultSkin ? 1 : svs.utils.paramHandler.get({
          key: 'skinId'
        }).value;
        const isVoucherCode = svs.utils.paramHandler.get({
          key: 'presentKod'
        }).value;
        if (isVoucherCode) {
          voucherCode = wagerId.toUpperCase();
          wagerId = null;
          ticketInfo = getSwishTicketInfo(availableTickets, ticketsConfig) || ticketInfo;
        }
        ticketInfo = _objectSpread(_objectSpread({}, ticketInfo), {}, {
          defaultSkin: availableTickets === null || availableTickets === void 0 || (_availableTickets$fin = availableTickets.find(ticket => ticketTypes.includes(ticket === null || ticket === void 0 ? void 0 : ticket.type.toLowerCase()))) === null || _availableTickets$fin === void 0 ? void 0 : _availableTickets$fin.defaultSkin
        });
      }
      const onClose = e => {
        e === null || e === void 0 || e.preventDefault();
        history.push("../../valja/".concat(ticketInfoMatch.params.ticketType));
      };
      return React.createElement(HiddenRoute, {
        displayPath: PLAY_PATH,
        url: match.url
      }, React.createElement(DispatcherRoute, {
        isMatch: Boolean(routeMatch)
      }, React.createElement(GameContainer, {
        appTimeline: appTimeline,
        demo: demo,
        hasUnscratchedTicket: hasUnscratchedTicket,
        history: history,
        onClose: onClose,
        skinId: skinId,
        ticketDispatcher: ticketDispatcher,
        ticketInfo: ticketInfo,
        ticketNumber: ticketNumber,
        voucherCode: voucherCode,
        wagerId: wagerId
      })));
    },
    path: "*"
  }), React.createElement(Route, {
    component: _ref3 => {
      let {
        match,
        history
      } = _ref3;
      const {
        ticketType,
        wagerId,
        gameIsCompleted
      } = svs.tickets.play.utils.utils.getTicketTypeFromWager(match.params.wagerId);
      const isOnGoingRoute = match.params.wagerId === 'pagaende';
      const onClose = e => {
        e === null || e === void 0 || e.preventDefault();
        window.location.href = svs.core.urlMapping.get('myBetsHome');
      };
      const ticketInfo = getTicketInfo(ticketType, ticketsConfig);
      return React.createElement(GameContainer, {
        appTimeline: appTimeline,
        excludeFooter: !isOnGoingRoute,
        fetchedGame: svs.tickets.data.fetchedGame,
        gameIsCompleted: gameIsCompleted,
        hasUnscratchedTicket: hasUnscratchedTicket,
        history: history,
        onClose: onClose,
        ticketDispatcher: ticketDispatcher,
        ticketInfo: ticketInfo,
        wagerId: wagerId
      });
    },
    exact: true,
    path: "/mina-spel/:wagerId"
  }), React.createElement(Route, {
    component: _ref4 => {
      let {
        match
      } = _ref4;
      const ticketType = match.params.ticketType;
      const ticketInfo = getMenuProduct(ticketType, menuProducts);
      if (ticketInfo !== null && ticketInfo !== void 0 && ticketInfo.defaultSkin) {
        ticketInfo.variations = 1;
      }
      appTimeline.pause();
      setTimeout(() => {
        appTimeline.resume();
      }, 100);
      if (!ticketInfo || !ticketInfo.type) {
        window.location.href = "../valja/".concat(menuProducts[0].type);
        return React.createElement("div", null);
      }
      ticketDispatcher.handleResponse('TICKETINFO_CHANGE', ticketInfo);
      return React.createElement(PlayContainer, {
        appTimeline: appTimeline,
        history: history,
        ticketDispatcher: ticketDispatcher,
        ticketInfo: ticketInfo
      });
    },
    exact: true,
    path: "/valja/:ticketType"
  }));
  ReactDOM.render(router, document.getElementById('reactContainer'));
};
svs.tickets.init();

 })(window);